export default "__VITE_ASSET__CNLgww3B__"